import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import http from './http/axios';
import VueClipboard from 'vue-clipboard2';
import { Datetime } from 'vue-datetime';

import 'vue-datetime/dist/vue-datetime.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueJsonToCsv from 'vue-json-to-csv'
import JsonExcel from './components/JsonExcel.vue';
import VueProgressBar from 'vue-progressbar';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { ReferenceChart } from 'vue-choropleth'
import InfoControl from './components/InfoControl.vue';
import ChoroplethLayer from './components/ChoroplethLayer.vue'
import 'leaflet/dist/leaflet.css';

Vue.prototype.$http = http;
// 後端 API 的網址 prefix
Vue.prototype.baseURL = process.env.VUE_APP_ROOT_API;

const options = {
  color: 'blue', // '#bffaf3',∂
  failedColor: '#874b4b',
  thickness: '3px',
  transition: {
    speed: '0.1s',
    opacity: '0.3s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
};
// 關閉正式環境下的提示功能，這裡可以先打開沒關係。
Vue.config.productionTip = false;

Vue.use(VueProgressBar, options);
Vue.component('VueJsonToCsv', VueJsonToCsv);
Vue.component('json-excel', JsonExcel);
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-info-control', InfoControl);
Vue.component('l-reference-chart', ReferenceChart);
Vue.component('l-choropleth-layer', ChoroplethLayer);
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard)
Vue.component('datetime', Datetime);

library.add(fas);
Vue.component('v-awesome-icon', FontAwesomeIcon)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
